import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsCustomerAccessRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-customer-access',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-access',
};
